import type { GenerateDomainListContactsStatus } from '@brandhub/types/brandhub';
import type { MediaContactList } from '@media-lists/types/mediaContactList';

export const isDomainListContactsJobInProgress = (
  status: GenerateDomainListContactsStatus | undefined,
): boolean => status?.status === 'queued' || status?.status === 'processing';

export const resolveDomainContactListIdForImport = (mediaList: MediaContactList): number =>
  mediaList.domainContactListId ?? mediaList.id;

export const isBrandHubDomainContactListImported = (
  status: GenerateDomainListContactsStatus | undefined,
): boolean => {
  if (!status) {
    return false;
  }
  if (status.status === 'imported') {
    return true;
  }
  return status.domainContactListStatus === 'imported';
};

export const shouldShowSyntheticGeneratingMediaList = (
  status: GenerateDomainListContactsStatus | undefined,
): boolean => {
  if (!status || isBrandHubDomainContactListImported(status)) {
    return false;
  }
  return isDomainListContactsJobInProgress(status);
};

export const shouldShowCompletedDomainContactListRow = (
  status: GenerateDomainListContactsStatus | undefined,
): boolean => {
  if (!status || isBrandHubDomainContactListImported(status)) {
    return false;
  }
  if (status.status !== 'completed') {
    return false;
  }
  return status.smartGroup?.id != null;
};

export const buildSyntheticDomainContactListRow = (
  status: GenerateDomainListContactsStatus,
): MediaContactList => {
  if (!status.smartGroup) {
    throw new Error('No smart group found in status');
  }
  const smartGroup = status.smartGroup;
  return {
    id: smartGroup.id,
    name: smartGroup.name,
    contactsCount: status.journalistsFoundCount ?? 0,
    generatedByAiVisibility: true,
    journalistsFoundCount: status.journalistsFoundCount ?? undefined,
    domainContactListId: status.domainContactListId,
    createdAt: status.finishedAt ?? status.startedAt ?? new Date().toISOString(),
    updatedAt: undefined,
    topics: smartGroup.topics,
  };
};
